// local
// actions
import { pending, rejected, fulfilled } from './async';
import dispatchError from './error';
import { showSnackbar } from './snackbar';
// api
import Account from 'app/api/account';

export const list = () => dispatch => {
    dispatch(pending('ACCOUNT_LIST'));
    Account.list()
        .then(payload => dispatch(fulfilled('ACCOUNT_LIST', payload)))
        .catch(err => {
            dispatch(rejected('ACCOUNT_LIST', err));
            dispatchError(dispatch, err);
        });
};

export const create = data => dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    Account.create(data)
        .then(payload => {
            dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
            dispatch({ type: 'ACCOUNT_LIST_CREATE', payload });
            dispatch(showSnackbar({ title: `O usuário ${payload.name} foi adicionado com sucesso!`, action: true }));
        })
        .catch(err => {
            dispatch(rejected('SAVE_UPDATE_MODAL', err));
            dispatchError(dispatch, err, false);
        });
};

export const update = (id, data) => dispatch => {
    dispatch(pending('SAVE_UPDATE_MODAL'));
    Account.update(id, data)
        .then(payload => {
            dispatch(fulfilled('SAVE_UPDATE_MODAL', payload));
            dispatch({ type: 'ACCOUNT_LIST_UPDATE', payload });
            dispatch(showSnackbar({ title: 'As alterações realizadas foram salvas.', action: true }));
        })
        .catch(err => {
            dispatch(rejected('SAVE_UPDATE_MODAL', err));
            dispatchError(dispatch, err, false);
        });
};

export const search = term => ({
    type: 'ACCOUNT_LIST_SEARCH',
    payload: term,
});

export const reset = () => ({
    type: 'ACCOUNT_LIST_RESET',
});
